import ParkingInformation from './parking-information.vue'
export default ParkingInformation
